import { Link } from "@tanstack/react-router";

import { ErrorAlert } from "../../components/ui/alert";
import { Card, CardTitle } from "../../components/ui/card";
import { formatDateTime } from "../search/format";
import { describeLinkCondition, describeLinkPrice } from "./card-format";
import { useLinkRequests } from "./card-queries";

/** On the Approvals page: every listing an employee sent, oldest first (D-64). */
export function LinkRequests() {
  const list = useLinkRequests(true);
  return (
    <section aria-labelledby="link-requests" className="flex flex-col gap-3">
      <h2 id="link-requests" className="text-lg font-semibold text-foreground">
        Listings to check {list.data !== undefined && `(${String(list.data.data.length)})`}
      </h2>
      {list.isError ? (
        <ErrorAlert error={list.error} />
      ) : list.data === undefined ? null : list.data.data.length === 0 ? (
        <Card>
          <p className="text-sm text-muted-foreground">No listings are waiting for you.</p>
        </Card>
      ) : (
        <ul className="flex flex-col gap-3">
          {list.data.data.map(({ cardName, link }) => (
            <li key={link.id}>
              <Card className="flex flex-wrap items-center justify-between gap-3 p-4">
                <div className="min-w-0">
                  <CardTitle className="text-base">{cardName}</CardTitle>
                  <p className="text-sm">
                    {link.website}: {describeLinkPrice(link)}
                  </p>
                  <p className="text-sm text-muted-foreground">{describeLinkCondition(link)}</p>
                  <p className="text-xs text-muted-foreground">
                    From {link.addedBy.name}
                    {link.askedAt !== null && ` · ${formatDateTime(link.askedAt)}`}
                  </p>
                </div>
                <Link
                  to="/cards/$cardId"
                  params={{ cardId: link.cardId }}
                  className="text-sm font-medium text-primary hover:underline"
                >
                  Open to approve or decline
                </Link>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
